
type Category = {
    category_id: number;
    description: string;
    name: string;
}

type Field = {
    confidence: ConfidenceLevel; // Use enum for type safety
    feedback?: string; // Optional feedback
    field_id: number;
    question: string;
    new_value?: string; // Editable value
    reasoning: string;
    answer: string;
}

enum ConfidenceLevel {
  High = "high",
  Low = "low",
  Medium = "medium",
  Missing = "missing",
}

enum ContextTabTypes {
  CategoryInstructions = "categoryInstructions",
  Documents = "documents",
  Reasoning = "reasoning",
  UserInstructions = "userInstructions",
}

export type CategoryWithFields = Category & {
  field_answers: Field[];
  instructions?: string;
};

export type CategoryIcon = {
  icon: string;
  slug: string;
};

// Extraction result types
export type FieldAnswer = {
  readonly answer: string;
  readonly confidence: ConfidenceLevel;
  readonly field_id: string;
  readonly question: string;
  readonly reasoning: string;
};

export type CategoryExtractionResult = {
  readonly category_id: string;
  field_answers: readonly FieldAnswer[];
  readonly model_type: "CategoryExtractionResult";
  readonly reasoning: string;
} & Record<string, Record<string, Field[]>>;

enum ExtractionResultStatus {
  PendingReview = "pending_review",
  Reviewed = "reviewed",
}

export type WebsiteExtractionResult = {
  readonly categories: readonly CategoryExtractionResult[];
  readonly created_at: string;
  readonly extraction_result_id: string;
  readonly extraction_result_status: ExtractionResultStatus;
  readonly insurance_line: string;
  readonly updated_at: string;
  readonly user_id: string;
  readonly website_name: string;
};

export type WebsiteField = {
  additional_info: string;
  field_id: string;
  field_name: string;
  field_slug: string;
}

export type WebsiteExtractionResultUpdateLog = {
  extraction_result_id: string;
  new_value: string | null;
  previous_value: string | null;
  reason: string;
  timestamp: string;
  update_id: string;
  updated_by: string;
  updated_category_id: string;
  updated_field_id: string | null;
  user_id: string;
  workflow_run_id: string;
}

export type WebsiteFieldCategory = {
  available_tools: string[];
  category_description: string;
  category_id: string;
  category_name: string;
  fields: WebsiteField[];
}


export type WebsiteSchema = {
  categories: WebsiteFieldCategory[];
  insurance_line: string;
  screenshots: string[];
  website_name: string;
}

export type CategoryInstruction = {
  instruction: string;
}

export type WebsiteInstructions = {
  category_instructions: Record<string, CategoryInstruction>;
  created_at: string;
  insurance_line: string;
  updated_at: string;
  user_id: string;
  website_name: string;
}

export type { Category, Field, CategoryWithFields, CategoryIcon };
export { ConfidenceLevel, ContextTabTypes, ExtractionResultStatus };
